import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import StatusCard from 'src/components/UI/addons/StatusCard';
import { useAutoTranslation } from 'src/hooks/useTranslate';

// Shared, GENERIC "this link is no longer valid" page — shown wherever someone
// opens a link that can no longer be used (expired, already submitted/used, or
// deactivated), across FHQ, custom forms and generate-link. Same StatusCard
// shape as the submission confirmation (error variant), so the two stay
// consistent. Copy is deliberately generic — no form-specific wording — since
// this surfaces in many places. Optional heading/subtext/note overrides for the
// rare caller that needs different words; defaults cover the common case.
export default function InvalidLinkPage({ heading, subtext, note }) {
  const t = useAutoTranslation();

  return (
    <StatusCard
      variant="error"
      heading={t(heading || 'This link is no longer valid')}
      subtext={t(subtext || 'It may have expired or already been used.')}
      note={
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            p: 2,
            border: '1px solid var(--color-border)',
            borderRadius: 2,
            bgcolor: 'var(--color-surface)',
            textAlign: 'left'
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t(
              note ||
                'Please contact the department that issued this link and they can send you a new one.'
            )}
          </Typography>
        </Paper>
      }
    />
  );
}
